export default () => ({
  pendingMedia: [],
  queueMedia: [],
  previousMedia: [],
  playingMedia: [],
  firstQueue: null,
  socketMediaShare: null,
})
